// extracted by mini-css-extract-plugin
export default {"contactTitleBox":"contactTitle_contactTitleBox__FW7eI"};